<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >BANDEIRAS CARTÕES</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn
            @click="novo()"
            v-show="$can('taxa_entrega.create|admin.loja')"
            color="topEnviados"
            dark
          >
            <v-icon>mdi-plus</v-icon>Nova
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsCategoria"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-2 pa-2"
      >
        <!--<template class="text-right" v-slot:item.chk_ativo="{ item }">
          <v-switch
            class="text-rigth"
            color="botao_sucesso"
            :label="`${checkStatus(item.chk_ativo)}`"
            @change="mudarStatus(item.id, item.chk_ativo)"
            v-model="item.chk_ativo == 1 ? true : false"
            value="item.chk_ativo"
          ></v-switch>
        </template>-->
        <template v-slot:item.ativo="{ item }">
          <v-switch
            dense
            color="green"
            :label="`${checkStatus(item.ativo)}`"
            @change="mudarStatus(item.id, item.ativo, 'ativo')"
            v-model="item.ativo"
            value
          ></v-switch>
        </template>
        <template v-slot:item.action="{ item }">
          <!--<v-icon class="mr-2" color="error" @click="excluirBaneira(item)"
            >delete</v-icon
          >-->
          <v-icon small color="btBlue" class="mr-2" @click="editBandeira(item)"
            >edit</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Cancelamento</v-card-title>
          <v-card-text>Deseja cancelar essa taxa?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialogCadastro" persistent max-width="50%">
      <v-card>
        <v-card-title class>
          <span v-if="cadastro">Cadastrar Bandeira</span>
          <span v-if="cadastro == false">Editar Bandeira</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row no-gutters>
              <v-col cols="4" md="7" lg="7" sm="6" xs="12">
                <v-text-field
                  v-model="bandeira.descricao"
                  label="Nome"
                  filled
                  dense
                  single-line
                  clearable
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" md="2" lg="2" sm="6" xs="12">
                <v-checkbox
                  v-model="bandeira.credito"
                  label="Crédito"
                  color="success"
                  :value="bandeira.credito"
                  false-value="0"
                  true-value="1"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2" lg="2" sm="6" xs="12">
                <v-checkbox
                  v-model="bandeira.debito"
                  color="success"
                  label="Débito"
                  :value="bandeira.debito"
                  false-value="0"
                  true-value="1"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" md="2" lg="2">
                <div class="mt-5">Imagem:</div>
              </v-col>
              <v-col cols="12" md="8" lg="1">
                <v-file-input
                  v-model="imageFile"
                  hide-input
                  filled
                  label="logo"
                  dense
                  @change="fileSelected"
                  prepend-icon="mdi-camera-plus"
                  accept="image/*"
                  hide-details
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-img
                max-height="150"
                max-width="150"
                :src="bandeira.logo"
                aspect-ratio="1.0"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="success" @click="gravar()" class="mr-4">
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="tempo"
      :color="error"
      :multi-line="multiline"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ textSnack }}
      <template v-slot:actions>
        <v-btn dark @click.native="snackbar = false">Fechar</v-btn></template
      >
    </v-snackbar>
    <v-snackbar
      :timeout="5000"
      :color="sucesso"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
      <template v-slot:actions>
        <v-btn dark @click.native="snackbarSuccess = false"
          >Fechar</v-btn
        ></template
      >
    </v-snackbar>
  </v-content>
</template>

<script>
import { mask, VueTheMask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    source: String,
  },
  data: () => ({
    singleLine: true,
    imageFile: [],
    footerProps: { "items-per-page-options": [30, 50, 100] },
    cadastro: true,
    bandeira: {
      descricao: "",
      logo: "",
      credito: 0,
      debito: 0,
      ativo: 1,
    },
    botao_sucesso: "botao_sucesso",
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false /* doesn't work with directive */,
    },
    error: "error",
    tempo: 5000,
    mode: "vertical",
    snackbar: false,
    textSnack: "",
    multiline: true,
    sucesso: "botao_sucesso",
    snackbarSuccess: false,

    textSucesso: "",

    cep: "",
    sheet: false,

    itemsUnidade: ["UN", "PC", "KG"],

    filtroProduto: "Produtos ",
    sv: false,
    carregaCep: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    itemsCategoria: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    selItem: "",

    //taxa: { bairro: "", vlr_taxa: "0,00", entrega_programada: false },
    headers: [
      {
        text: "Bandeira",
        align: "left",
        sortable: true,
        value: "descricao",
      },
      {
        text: "Status",
        value: "ativo",
        sortable: true,
        align: "left",
      },
      { text: "Ação", value: "action", sortable: false },
    ],
  }),

  mounted() {
    //this.buscaProdutos();

    this.buscaBandeiras();
  },
  methods: {
    editBandeira(item) {
      this.cadastro = false;
      this.dialogCadastro = true;
      this.bandeira.id = item.id;
      this.bandeira.descricao = item.descricao;
      this.bandeira.logo = item.logo;
      this.bandeira.debito = item.debito;
      this.bandeira.credito = item.credito;
    },
    fileSelected(evt) {
      this.bandeira.logo = URL.createObjectURL(evt);
    },
    mudarStatus(id, status, tipo) {
      axios
        .post(`/bandeiras_cartao/status`, { id: id, ativo: status, tipo: tipo })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Status alterado!";
            this.buscaBandeiras();
          }
        });
    },
    checkStatus(valor) {
      if (valor == 1) {
      return "Ativo";
      } else {
        return "Inativo ";
      }
    },

    limpaCampos() {
      this.bandeira.descricao = "";
      this.bandeira.credito = 0;
      this.bandeira.debito = 0;
      this.bandeira.logo = "";
    },
    novo() {
      this.dialogCadastro = true;
      this.cadastro = true
      this.limpaCampos();
    },
    excluirTaxa(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },
    deleta() {
      axios.post(`/taxa/delete`, { id: this.selItem }).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.buscaBandeiras();
          this.itemEdit = "";
          this.dialogCancel = false;
          this.selProduto = "";
        }
      });
    },
    editProduto(item) {
      this.dialog = true;
      this.itemEdit = item.id;
    },
    buscaBandeiras() {
      this.loading_table = true;
      axios.get(`/bandeiras_cartao/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsCategoria = response.data;
        }
      });
    },
    async gravar() {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      //console.log(this.file);

      var formData = new FormData();

      // var imagefile = document.querySelector("#avatar");
      //formData.append("image", imagefile.files[0]);
      formData.append("image", this.imageFile);
      formData.append("bandeira", JSON.stringify(this.bandeira));

     await axios
        .post(`/bandeiras_cartao`, formData, config)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Operação concluída com sucesso!";
            this.buscaBandeiras();
            this.itemEdit = "";
            this.selProduto = "";
            this.limpaCampos();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
        if(!this.cadastro){
          this.dialogCadastro = false
        }
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 0px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.v-data-table td {
  font-size: 0.685rem !important;
}

.v-messages {
  min-height: 0px !important;
}
</style>
